import { useDateFormatter } from '@repo/utils/date';
import { lazy, Suspense } from 'react';

import { CustomerInfoWithLevel } from '../../../../hooks/useCustomerOverview';
import { BannerContent } from '../BannerContent/BannerContent';

import styles from './Banner.module.css';

const LoyaltyPet = lazy(() => import('./banner-pets.svg'));

export interface BannerProps {
  isCustomerLoggedIn: boolean;
  customerInfo?: CustomerInfoWithLevel;
}

export const Banner = ({ isCustomerLoggedIn, customerInfo }: BannerProps) => {
  const formatDate = useDateFormatter();

  return (
    <div className={styles.banner} data-testid="welcome-banner">
      <div className={styles.bannerBody}>
        <BannerContent
          isCustomerLoggedIn={isCustomerLoggedIn}
          isBasicCustomer={customerInfo?.loyaltyLevel.type === 'BASIC'}
          endDate={
            customerInfo?.loyaltyLevel.endDate ? formatDate(customerInfo.loyaltyLevel.endDate) : ''
          }
        />
      </div>
      <Suspense fallback={null}>
        <LoyaltyPet
          data-testid="loyalty-pets-image"
          title="Loyalty Pets"
          className={styles.image}
          aria-hidden
        />
      </Suspense>
    </div>
  );
};
